"use strict";

Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.apiProduct_post = exports.api_product_post_failure = exports.api_product_post_success = exports.api_product_post_request = exports.API_PRODUCT_POST_FAILURE = exports.API_PRODUCT_POST_SUCCESS = exports.API_PRODUCT_POST_REQUEST = undefined;

var _index = require("axios/index");

var _index2 = _interopRequireDefault(_index);

var _nodeToolbox = require("@esnpm/node-toolbox");

var _bluebird = require("bluebird");

var _bluebird2 = _interopRequireDefault(_bluebird);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var API_PRODUCT_POST_REQUEST = exports.API_PRODUCT_POST_REQUEST = "API_PRODUCT_POST_REQUEST";
var API_PRODUCT_POST_SUCCESS = exports.API_PRODUCT_POST_SUCCESS = "API_PRODUCT_POST_SUCCESS";
var API_PRODUCT_POST_FAILURE = exports.API_PRODUCT_POST_FAILURE = "API_PRODUCT_POST_FAILURE";

var api_product_post_request = exports.api_product_post_request = function api_product_post_request(options) {
	return {
		type: API_PRODUCT_POST_REQUEST,
		options: options,
		payload: {
			loading: true
		}
	};
};

var api_product_post_success = exports.api_product_post_success = function api_product_post_success(data) {
	return {
		type: API_PRODUCT_POST_SUCCESS,
		payload: {
			loading: false,
			data: data,
			error: null
		}
	};
};

var api_product_post_failure = exports.api_product_post_failure = function api_product_post_failure(error) {
	return {
		type: API_PRODUCT_POST_FAILURE,
		payload: {
			loading: false,
			error: error
		}
	};
};

/*
	Products.apiProduct_post
*/
var apiProduct_post = exports.apiProduct_post = function apiProduct_post(options) {
	return (
		// eslint-disable-next-line no-unused-vars
		function (dispatch, getState) {
			return new _bluebird2.default(
			// eslint-disable-next-line no-unused-vars
			function (resolve, reject) {
				dispatch(api_product_post_request(options));
				var url = (0, _nodeToolbox.getAPIUrl)([{ "parameters": [], "url": "/api/product" }, { "parameters": ["SKU"], "url": "/api/product/${options.SKU}" }], options);
				(0, _index2.default)({
					method: "post",
					url: url,
					params: {
						PROCESSING: options.PROCESSING,
						SAVE: options.SAVE,
						VALIDATE: options.VALIDATE
					},
					data: {
						ACTION_HISTORY: options.ACTION_HISTORY,
						ASSETS: options.ASSETS,
						ATTRIBUTES: options.ATTRIBUTES,
						CALCULATION: options.CALCULATION,
						CATEGORY_PATH: options.CATEGORY_PATH,
						CHILDREN: options.CHILDREN,
						CREATED: options.CREATED,
						CROSS_SELLING: options.CROSS_SELLING,
						CROSS_SELLING_MASTER: options.CROSS_SELLING_MASTER,
						DANGEROUS_GOODS_INFO: options.DANGEROUS_GOODS_INFO,
						DATA_COMPATIBILITY: options.DATA_COMPATIBILITY,
						DELIVERY_DATE: options.DELIVERY_DATE,
						DELIVERY_TIME_WORKING_DAYS: options.DELIVERY_TIME_WORKING_DAYS,
						EAN: options.EAN,
						EXTERN_CATEGORIES: options.EXTERN_CATEGORIES,
						FLAGS: options.FLAGS,
						INTRASTAT: options.INTRASTAT,
						MANUFACTURER: options.MANUFACTURER,
						NEEDED_ATTRIBUTES: options.NEEDED_ATTRIBUTES,
						NOT_VALID_FOR_DATA_COMPATIBILITY: options.NOT_VALID_FOR_DATA_COMPATIBILITY,
						PRODUCT_TYPE: options.PRODUCT_TYPE,
						PURCHASE: options.PURCHASE,
						REQUESTED_DATA_COMPATIBILITY: options.REQUESTED_DATA_COMPATIBILITY,
						SALE: options.SALE,
						SELLING_PLATFORMS: options.SELLING_PLATFORMS,
						SIZES: options.SIZES,
						SKU: options.SKU,
						STATUS: options.STATUS,
						STOCK: options.STOCK,
						STOCK_SUMMARY: options.STOCK_SUMMARY,
						SUCCESSOR_SKU: options.SUCCESSOR_SKU,
						SUPPLIERS: options.SUPPLIERS,
						SURCHARGE_DISCOUNT_COST: options.SURCHARGE_DISCOUNT_COST,
						TEXTS: options.TEXTS,
						UNIT: options.UNIT,
						UPDATED: options.UPDATED,
						VALIDATED_FIELDS: options.VALIDATED_FIELDS
					}
				}).then(function (response) {
					if (response.data.SUCCESSFUL) {
						dispatch(api_product_post_success(response.data.DATA));
						resolve();
					} else {
						dispatch(api_product_post_failure(response.data));
						resolve();
					}
				}, function (err) {
					// eslint-disable-next-line no-console
					console.log(err);
					reject();
				});
			});
		}
	);
};